/**
 * Created by BFR on 24/02/2020.
 */
define('editPimPrintZoneView',[
  'module',
  'settings',
  'marionette',
  'backbone',
  'jquery',
  'app',
  'underscore',
  'template!editPimPrintZoneTpl',
  'pimUtil',
  'dynamicTextView',
  'bootbox'
], function (
  module,
  Settings,
  Marionette,
  Backbone,
  $,
  App,
  _,
  viewTpl,
  PimUtil,
  DynamicTextView,
  bootbox
) {
  'use strict';

  var EditPimPrintZoneView = Marionette.LayoutView.extend({
    template: viewTpl,
    className: 'printzone',

    regions: {
      nameRegion: '.pz-name-region'
    },

    events: {
      'change .js-upload-pz-template': 'onUploadTemplate',
      'click .js-delete-pz-template': 'onDeleteTemplate'
    },

    onShow: function () {
      this.setupContent();
    },

    /**
     * Everything that needs the rendered DOM (glossary icon, image popover).
     * Called on first show and again after a re-render triggered by a template upload/delete.
     */
    setupContent: function () {

      if (this.model.get('refImprintTechnology').get('name').get('glossaryDt')) {
        this.nameDtView = new DynamicTextView({
          model: this.model.get('refImprintTechnology').get('name').get('glossaryDt'),
          hideGlossary: true,
          showWebIcon: true
        });
        this.getRegion('nameRegion').show(this.nameDtView);
      }

      var aImages = this.model.get('printPictures');

      if (aImages.length > 0) {
        var url = aImages[0].imageUrl;

        var content = '<div class="img-responsive"><img class="img-popover" src="' + url + '"/></div>';

        var target = this.$el.find('.image img');

        target.attr('data-content', content);
        var popover = target.popover({
          trigger: 'hover',
          placement: 'left',
          html: 'true',
          container: $('#content')
        }).data('bs.popover');
        if (popover) {
          popover.tip().addClass('jqgrid-popover');
        }
      }
    },

    onDestroy: function () {
      $('.jqgrid-popover').remove();
    },

    serializeData: function () {
      var templateData = {};
      var aNames = this.model.get('refImprintTechnology').get('name').get('values');
      templateData.name = PimUtil.getTranslation(aNames);
      templateData.imppCode = this.model.get('refImprintTechnology').get('code');
      templateData.width = this.model.get('width');
      templateData.height = this.model.get('height');
      templateData.setupCode = this.model.get('setupCode');
      templateData.unitCode = this.model.get('unitCode');
      templateData.advancedMode = false;
      if(Settings.configValue('advancedMode') === true)
        templateData.advancedMode = true;
      templateData.fastDelivery = this.model.get('fastDelivery');
      templateData.productionTimes = '';
      if (this.model.get('productionTimes') && this.model.get('productionTimes').length) {
        _.each(this.model.get('productionTimes'), function (oProductionTime) {
          templateData.productionTimes += oProductionTime.from + '-' + oProductionTime.to + ': ' +oProductionTime.days + '\n';
        });
      }
      templateData.imageUrl = '';
      if (this.model.get('refImprintTechnology') && this.model.get('refImprintTechnology').get('colorModeType') === 'spot') {
        templateData.maxColors = this.model.get('maxColors');
      } else {
        templateData.maxColors = '';
      }
      if (this.model.get('refImprintTechnology') && this.model.get('refImprintTechnology').get('colorModeType') === 'quadri') {
        templateData.digital = true;
      } else {
        templateData.digital = '';
      }
      if (this.model.get('refImprintTechnology') && this.model.get('refImprintTechnology').get('colorModeType') === 'fixedFilling') {
        templateData.eng = true;
      } else {
        templateData.eng = '';
      }
      var aImages = this.model.get('printPictures');

      if (aImages.length > 0) {
        templateData.imageUrl = aImages[0].imageUrl;
      }

      templateData.allowUpload = false;

      if (this.options.pimProduct.getCurrentResProduct()) {
        templateData.allowUpload = true;
      }

      templateData.pimId = this.model.get('pimId');
      templateData.templates = this.getTemplates();

      return templateData;
    },

    /**
     * Reseller PDF templates attached to this print zone (stored on the reseller product
     * as `pzTemplates`, filtered by the print zone pimId).
     */
    getTemplates: function () {
      var resProduct = this.options.pimProduct.getCurrentResProduct();
      if (!resProduct) {
        return [];
      }
      var pzId = this.model.get('pimId');
      return _.filter(resProduct.get('pzTemplates') || [], function (template) {
        return template.pzId === pzId;
      });
    },

    /**
     * Replace this print zone's templates in the reseller product with the list returned by the server.
     */
    setTemplates: function (templates) {
      var resProduct = this.options.pimProduct.getCurrentResProduct();
      if (!resProduct) {
        return;
      }
      var pzId = this.model.get('pimId');
      var others = _.filter(resProduct.get('pzTemplates') || [], function (template) {
        return template.pzId !== pzId;
      });
      resProduct.set('pzTemplates', others.concat(templates || []));
      this.render();
      this.setupContent();
    },

    onUploadTemplate: function (e) {
      var resProduct = this.options.pimProduct.getCurrentResProduct();
      if (!resProduct || !e.target.files || !e.target.files.length) {
        return;
      }
      var formData = new FormData();
      for (var i = 0; i < e.target.files.length; i++) {
        formData.append('file', e.target.files[i]);
      }
      this.$el.find('.pz-template-upload').addClass('uploading');

      $.when(App.request('pim:products:upload-printzone-template', resProduct.get('id'), this.model.get('pimId'), formData))
        .done(_.bind(function (templates) {
          this.setTemplates(templates);
        }, this))
        .fail(_.bind(function (xhr) {
          this.$el.find('.pz-template-upload').removeClass('uploading');
          var message = xhr && xhr.responseText ? xhr.responseText : 'Error uploading template';
          bootbox.alert(message);
        }, this));
    },

    onDeleteTemplate: function (e) {
      var resProduct = this.options.pimProduct.getCurrentResProduct();
      var uid = $(e.currentTarget).attr('data-uid');
      if (!resProduct || !uid) {
        return;
      }
      bootbox.confirm(_.i18n('common.confirmDelete'), _.bind(function (result) {
        if (!result) {
          return;
        }
        $.when(App.request('pim:products:delete-printzone-template', resProduct.get('id'), this.model.get('pimId'), uid))
          .done(_.bind(function (templates) {
            this.setTemplates(templates);
          }, this))
          .fail(function () {
            bootbox.alert('Error deleting template');
          });
      }, this));
    }
  });

  module.exports = EditPimPrintZoneView;
});
